import { Table, Image } from "antd";
import { LuShip } from "react-icons/lu";
import { IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { PiWarning } from "react-icons/pi";
import "../style.scss"
function DataTable(props: any) {
  const navigate = useNavigate();

  const detailScreen = (id: any) => {
    const encodedId = btoa(id);
    navigate(`/auth/DgTwinDetails/${encodedId}`);
  };

  const columns = [
    {
      title: "Sender Code",
      dataIndex: "senser_code",
      key: "id",
      width: 318,
    },
    {
      title: "Digital Twin ID",
      dataIndex: "digital_twin_id",
      key: "id",
      width: 318,
    },
    {
      title: "Time & Date",
      key: "id",
      width: 318,
      render : (data:any) =>(
        `${data?.time} || ${data?.date}`
      )
    },
    {
      title: "Key",
      dataIndex:"key",
      key: "id",
      width: 176,
    },
    {
      title: "Value",
      dataIndex:"value",
      key: "id",
      width: 176,
    },
    {
      title: "Unit",
      key: "id",
      width: 176,
      render:(data:any)=>(
        <div className="d-flex gap-5 align-items-center">
            {`${data?.unit}`}<PiWarning onClick={()=>{navigate(`/auth/measurements/details/${encodeURIComponent(data?.digital_twin_id)}`)}} style={{strokeWidth:2,color: data?.event_type === "alert" ? 'red' : '#f9da7f'}} className="table-icon"/>
        </div>
      )
    }
  ];

  const components = {
    header: {
      cell: ({ className, children, ...restProps }:any) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#087EA4',
            color:"#FFFFFF",
            fontSize:14,
            fontFamily:"Inter-SemiBold"      
          }}
          className="measurement-table-header"
        >
          {children}
        </th>
      ),
    },
    body: {
        cell: ({ className, children, ...restProps }: any) => (
          <td
            {...restProps}
            style={{
              backgroundColor: '#FFFFFF', 
              color: '#000000',              
              fontSize: 14,               
              fontFamily: 'Inter-Regular' 
            }}
            className={className} 
          >
            {children}
          </td>
        ),
      },
  };

  
  return (
    <div>
      <Table
        size="small"
        dataSource={props?.data}
        columns={columns}
        loading={props?.loading}
        components={components}
        bordered
      />
    </div>
  );
}

export default DataTable;
